import { createFileRoute, Outlet, useNavigate } from "@tanstack/react-router"
import { Crumb } from "modules/shared/lib/breadcrumbs"

import { useAuthEmployeeQuery } from "modules/auth/hooks/useAuthEmployeeQuery"
import "modules/backoffice/lang"
import { hasBackofficeAccess } from "schema"

const BackofficeWrapper = () => {
  const { data, isPending } = useAuthEmployeeQuery()
  const navigate = useNavigate()

  if (isPending || !data) {
    return null
  }

  if (!hasBackofficeAccess(data.backofficeType)) {
    navigate({ to: "/" })
    return null
  }

  return <Outlet />
}

export const Route = createFileRoute("/_base/_auth/backoffice")({
  component: BackofficeWrapper,
  loader: ({ route: { fullPath } }) => {
    return new Crumb({
      fullPath,
      title: (t) => t("backoffice.header.title"),
    })
  },
})
